import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import dateUtil from '../utils/date.util'
import itemApi, { ItemData } from '../apis/item.api'
import locationApi, { LocationData } from '../apis/location.api'
import {
  PalletStatus, statuses as palletStatuses
} from '../apis/pallet.api'
import locationService from '../services/location.service'
import itemService from '../services/item.service'
import SearchPicker, { SearchPickerOption } from '../components/SearchPicker'
import Card from '../components/Card'
import Row from '../components/Row/Row'
import Select from '../components/Select'
import CustomDatePicker from '../components/CustomDatePicker'
import PageHeading from '../components/PageHeading'
import Checkbox from '../components/Checkbox'
import ReportButtons from '../partials/ReportButtons'

interface Props {
  onSearchClick: (data: InventoryReportFormData) => void
  onExportClick: (data: InventoryReportFormData) => void
}

interface State {
  fromDate: string
  toDate: string
  status: PalletStatus
  locationId: string
  item: string
  itemId: number | null
  includeHistory: boolean
  locations: LocationData[]
  items: ItemData[]
}

export interface InventoryReportFormData {
  fromDate: string
  toDate: string
  status: PalletStatus
  locationId: string
  itemId: number | null
  includeHistory: boolean
}

export default class InventoryReportForm extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      fromDate: dateUtil.now(),
      toDate: dateUtil.now(),
      status: 'inventory',
      locationId: '',
      item: '',
      itemId: null,
      includeHistory: false,
      locations: [],
      items: []
    }
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleItemSearch = this.handleItemSearch.bind(this)
    this.handleItemSelect = this.handleItemSelect.bind(this)
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
    this.handleSearchClick = this.handleSearchClick.bind(this)
    this.handleExportClick = this.handleExportClick.bind(this)
    this.handleItemBlur = this.handleItemBlur.bind(this)
  }

  get locationSelectOptions () {
    return locationService.selectOptions(this.state.locations)
  }

  get itemSearchOptions () {
    return itemService.searchOptions(this.state.items)
  }

  get formData (): InventoryReportFormData {
    const { fromDate, toDate, status, locationId } = this.state
    const { itemId, includeHistory } = this.state
    return { fromDate, toDate, status, locationId, itemId, includeHistory }
  }

  listLocations () {
    locationApi.list(locations => {
      if (!locations) return
      this.setState({ locations })
    })
  }

  searchItem (term: string) {
    itemApi.search(term, items => {
      if (!items) return
      this.setState({ items })
    })
  }

  handleCheckboxChange (name: string) {
    if (name === 'includeHistory') {
      this.setState(state => {
        const includeHistory = !state.includeHistory
        return { includeHistory }
      })
    }
  }

  handleDateChange (name: string, date: string) {
    if (name === 'from') this.setState({ fromDate: date })
    if (name === 'to') this.setState({ toDate: date })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'locationId') this.setState({ locationId: value })
    if (name === 'item') this.setState({ itemId: null, item: value })
    if (name === 'status') {
      const status = value as PalletStatus
      this.setState({ status })
    }
  }

  handleItemSearch (name: string, term: string) {
    this.searchItem(term)
  }

  handleItemSelect (name: string, option: SearchPickerOption) {
    const itemId = option.id as number
    this.setState({ itemId, items: [] })
  }

  handleItemBlur () {
    this.setState({ items: [] })
  }

  handleSearchClick () {
    this.props.onSearchClick(this.formData)
  }

  handleExportClick () {
    this.props.onExportClick(this.formData)
  }

  componentDidMount () {
    this.listLocations()
  }

  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("Inventory Report")}
          doc='reports-preview-and-export-inventories-report' />
        <Row column={2}>
          <CustomDatePicker
            from={this.state.fromDate}
            to={this.state.toDate}
            time={true}
            onChange={this.handleDateChange} />
          <Row column={2}>
            <Select
              name="status"
              value={this.state.status}
              options={palletStatuses}
              label={i18n("Status")}
              onChange={this.handleInputChange} />
            <Select
              name="locationId"
              value={this.state.locationId}
              options={this.locationSelectOptions}
              label={i18n("Location")}
              onChange={this.handleInputChange} />
            <SearchPicker
              name="item"
              value={this.state.item}
              options={this.itemSearchOptions}
              label={i18n("Item")}
              onSearch={this.handleItemSearch}
              onChange={this.handleInputChange}
              onSelect={this.handleItemSelect}
              onBlur={this.handleItemBlur} />
            <Checkbox
              name="includeHistory"
              label="Include history"
              checked={this.state.includeHistory}
              align="center"
              onChange={this.handleCheckboxChange} />
          </Row>
        </Row>
        <ReportButtons
          onSearch={this.handleSearchClick}
          onExport={this.handleExportClick} />
      </Card>
    )
  }
}
